import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const ICON_OPTIONS = [
    'fas fa-plane','fas fa-hotel','fas fa-users','fas fa-tags','fas fa-tint','fas fa-wifi',
    'fas fa-user-tie','fas fa-shield-alt','fas fa-star','fas fa-utensils','fas fa-bus','fas fa-comments',
    'fas fa-check','fas fa-heart','fas fa-gem','fas fa-crown','fas fa-thumbs-up','fas fa-medal',
    'fas fa-camera','fas fa-map-marker-alt','fas fa-clock','fas fa-suitcase','fas fa-passport','fas fa-globe-asia'
];

export class HighlightMaster extends Component {
    state = { items: [], loading: true, editing: null };

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        fetch('api/programplus/highlights/master')
            .then(r => r.json())
            .then(j => this.setState({ items: j, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    save(e) {
        e.preventDefault();
        var ed = this.state.editing;
        if (!ed.text) { alert('กรุณากรอกข้อความ'); return; }
        fetch('api/programplus/highlights/master', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(ed)
        }).then(r => {
            if (r.ok) { this.setState({ editing: null }); this.load(); }
        });
    }

    del(item) {
        if (!window.confirm('ลบ "' + item.text + '" ?')) return;
        fetch('api/programplus/highlights/master/' + item.id, { method: 'DELETE' })
            .then(r => { if (r.ok) this.load(); });
    }

    render() {
        const { items, loading, editing } = this.state;
        return (
            <div style={{ padding: 20 }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>ทั้งหมด {items.length} รายการ</p>
                    <button className="btn btn-danger" onClick={() => this.setState({ editing: { id: 0, text: '', icon: 'fas fa-check' } })}>
                        <i className="fas fa-plus"></i> เพิ่มจุดเด่น
                    </button>
                </div>

                {editing && (
                    <form onSubmit={e => this.save(e)} className="card mb-3">
                        <div className="card-header"><strong>{editing.id === 0 ? 'เพิ่ม' : 'แก้ไข'}จุดเด่น</strong></div>
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-3">
                                    <label className="form-label fw-bold">Icon</label>
                                    <select className="form-control" style={{color:'#333'}} value={editing.icon}
                                        onChange={e => this.setState({ editing: {...editing, icon: e.target.value} })}>
                                        {ICON_OPTIONS.map(ic => <option key={ic} value={ic} style={{color:'#333'}}>{ic}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-1 text-center pt-4">
                                    <i className={editing.icon} style={{ fontSize: 24, color: '#dc3545' }}></i>
                                </div>
                                <div className="col-md-8">
                                    <label className="form-label fw-bold">ข้อความ</label>
                                    <input type="text" className="form-control" value={editing.text} autoFocus
                                        onChange={e => this.setState({ editing: {...editing, text: e.target.value} })} placeholder="เช่น สายการบินระดับชาติ"/>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end" style={{gap:8}}>
                                <button type="button" className="btn btn-outline-secondary" onClick={() => this.setState({ editing: null })}>ยกเลิก</button>
                                <button type="submit" className="btn btn-success"><i className="fas fa-save"></i> บันทึก</button>
                            </div>
                        </div>
                    </form>
                )}

                {loading ? <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>
                : (
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead style={{ background: '#f8f9fa' }}>
                                <tr>
                                    <th style={{ width: 60 }}>#</th>
                                    <th style={{ width: 60, textAlign: 'center' }}>Icon</th>
                                    <th>ข้อความ</th>
                                    <th style={{ width: 200 }}>Class</th>
                                    <th style={{ width: 120, textAlign: 'center' }}>จัดการ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((it, i) => (
                                    <tr key={it.id}>
                                        <td style={{ color: '#aaa' }}>{i + 1}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            <span style={{ width: 32, height: 32, borderRadius: '50%', background: '#dc3545', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <i className={it.icon}></i>
                                            </span>
                                        </td>
                                        <td>{it.text}</td>
                                        <td><code style={{ fontSize: 11 }}>{it.icon}</code></td>
                                        <td style={{ textAlign: 'center' }}>
                                            <button className="btn btn-outline-primary btn-sm me-1" style={{ marginRight: 4 }}
                                                onClick={() => this.setState({ editing: {...it} })}><i className="fas fa-edit"></i></button>
                                            <button className="btn btn-outline-danger btn-sm" onClick={() => this.del(it)}><i className="fas fa-trash"></i></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }
}
